import { Platform } from './index.d';

export const platform: Platform = {
  wechat: !!navigator.userAgent.match(/MicroMessenger/i),
  android: !!navigator.userAgent.match(/Android/i),
  ios: !!navigator.userAgent.match(/(iPhone\sOS)\s([\d_]+)/)
};
